export default __webpack_public_path__ + "5a8c5a8cef138e47c72e441478f04ced.svg";